<div
  class="w-full rounded-2xl border border-neutral-3 bg-neutral-1 p-3 sm:p-4 shadow-xs flex flex-col lg:flex-row lg:items-center justify-between gap-4 transition-all hover:border-neutral-4"
>
  <!-- LEFT: PROPERTY INFO WITH HOVER PREVIEW -->
  <div
    class="group/preview flex items-center gap-3.5 cursor-pointer select-none min-w-0"
    [etxePropertyHoverPreview]="property()"
    (click)="onCardClick()"
    (keydown.enter)="onCardClick()"
    (keydown.space)="onCardClick(); $event.preventDefault()"
    tabindex="0"
    role="button"
    aria-label="Aperçu rapide du bien au survol"
  >
    <!-- Cover thumbnail -->
    <div
      class="relative size-14 sm:size-16 rounded-xl overflow-hidden bg-neutral-2 border border-neutral-3 shrink-0 flex items-center justify-center transition-transform group-hover/preview:scale-[1.02]"
    >
      @if (coverPhotoUrl(); as url) {
        <img [src]="url" alt="Photo du bien" class="h-full w-full object-cover" />
      } @else {
        <mat-icon class="size-7 !text-2xl text-neutral-9">home</mat-icon>
      }

      <!-- Subtle hover badge overlay -->
      <div
        class="absolute inset-0 bg-neutral-12/20 backdrop-blur-[1px] opacity-0 group-hover/preview:opacity-100 transition-opacity flex items-center justify-center"
      >
        <mat-icon class="size-5 !text-lg text-white">visibility</mat-icon>
      </div>
    </div>

    <!-- Details Column -->
    <div class="flex flex-col min-w-0 gap-1">
      <div class="flex flex-wrap items-center gap-2">
        <h2
          class="text-base sm:text-lg font-bold text-neutral-12 m-0 truncate group-hover/preview:text-indigo-11 transition-colors"
        >
          {{ property().definition?.propertyType | etxeEnumDisplay: 'propertyType' }}
          @if (property().presentation?.title; as title) {
            <span class="text-neutral-10 font-normal">· {{ title }}</span>
          }
        </h2>

        @if (reference(); as ref) {
          <span
            class="px-2 py-0.5 text-xs font-semibold rounded-md bg-neutral-3 text-neutral-11 border border-neutral-4 shrink-0"
          >
            Réf. {{ ref }}
          </span>
        }
      </div>

      <div class="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-neutral-10">
        @if (city(); as c) {
          <span class="flex items-center gap-1 font-medium text-neutral-11">
            <mat-icon class="!text-sm size-3.5 text-neutral-9">place</mat-icon>
            {{ c }}
            @if (zipCode(); as zip) {
              ({{ zip }})
            }
          </span>
        }

        <span
          class="inline-flex items-center gap-1 text-[11px] font-medium text-indigo-11 bg-indigo-2 px-2 py-0.5 rounded-md border border-indigo-3/80 group-hover/preview:bg-indigo-3 transition-colors"
        >
          <mat-icon class="!text-xs size-3">info</mat-icon>
          <span>Survoler pour détails</span>
        </span>
      </div>
    </div>
  </div>

  <!-- CENTER / METRICS PILLS -->
  <div
    class="flex flex-wrap items-center gap-2 shrink-0 py-1 lg:py-0 border-t lg:border-t-0 border-neutral-3 pt-3 lg:pt-0"
  >
    @if (habitableSurface(); as s) {
      <div
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-neutral-2 border border-neutral-3 text-xs font-semibold text-neutral-12"
        matTooltip="Surface habitable"
      >
        <mat-icon class="!text-sm size-4 text-neutral-10">square_foot</mat-icon>
        <span>{{ s }} m²</span>
      </div>
    }

    @if (totalPieces() > 0) {
      <div
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-neutral-2 border border-neutral-3 text-xs font-semibold text-neutral-12"
        matTooltip="Nombre de pièces"
      >
        <mat-icon class="!text-sm size-4 text-neutral-10">meeting_room</mat-icon>
        <span>{{ totalPieces() }} pièces</span>
      </div>
    }

    @if (sellingPriceEuros(); as p) {
      <div
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-indigo-2 border border-indigo-4/70 text-xs font-bold text-indigo-11"
        matTooltip="Prix net vendeur"
      >
        <mat-icon class="!text-sm size-4 text-indigo-10">payments</mat-icon>
        <span>{{ p | number: '1.0-0' : 'fr-FR' }} €</span>
        <span class="text-[10px] text-indigo-10 font-normal">net vend.</span>
      </div>
    }

    <!-- ACTIONS SLOT -->
    <div class="flex items-center gap-2 pl-0 sm:pl-2">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
</div>
